export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DatosSocioeconomicos.vue?vue&type=template&id=35d08872&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/components/forms/DatosSocioeconomicos.vue?vue&type=template&id=35d08872&scoped=true&
// module id = 655
// module chunks = 5